import {CANONICAL_ORIGIN, isNoIndexUrl} from './seo';

/** Only advertise indexable, canonical translations as language alternatives. */
export function languageAlternates(
  canonicalPageUrl: string,
  requestUrl = canonicalPageUrl,
  noIndex = false,
) {
  if (noIndex || isNoIndexUrl(requestUrl)) return [];
  try {
    const canonical = new URL(canonicalPageUrl);
    // Taiwan is a separate market; its equivalent HK pages are not inferred.
    if (canonical.origin !== CANONICAL_ORIGIN) return [];
    const path =
      canonical.pathname.replace(/^\/(en|zh-cn)(?=\/|$)/i, '') || '/';
    const suffix = path === '/' ? '' : path;
    const zh = `${CANONICAL_ORIGIN}${path}${canonical.search}`;
    const en = `${CANONICAL_ORIGIN}/en${suffix}${canonical.search}`;
    return [
      {hrefLang: 'zh-Hant', href: zh},
      {hrefLang: 'en', href: en},
      {hrefLang: 'x-default', href: zh},
    ];
  } catch {
    return [];
  }
}

/** Apply the same policy to HTML, resource routes and early server failures. */
export function withIndexingHeaders(request: Request, response: Response) {
  if (response.status < 400 && !isNoIndexUrl(request.url)) return response;
  const headers = new Headers(response.headers);
  headers.set('X-Robots-Tag', 'noindex, follow');
  return new Response(response.body, {
    status: response.status,
    statusText: response.statusText,
    headers,
  });
}
